import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import moment from "moment";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Pagination from "../../components/pagination/paginationView";
import { getComplaintsList } from "../../action/complaints";
import { Loader } from "../loader";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";

const CompletedRequest = () => {
  const [curPendingData, setCurPendingData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [showImage, setShowImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompletedRequests = async () => {
      setLoading(true);
      const response = await getComplaintsList(pageSize, pageNo, "COMPLETE");
      if (response.status) {
        setCurPendingData(response.data?.list || []);
        setTotalCount(response.data?.count || 0);
      }
      setLoading(false);
    };

    fetchCompletedRequests();
  }, [pageNo, pageSize]);

  return (
    <div className="payout_data-content" style={{ height: "100%" }}>
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              <Breadcrumb
                paths={[{ name: "Complaints" }, { name: "Completed" }]}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="tab_box">
        <div className="table-responsive">
          <table className="payout_table upi-mandate_table">
            <thead>
              <tr className="tableHead">
                <th className="thHeader">Ticket ID</th>
                <th className="thHeader">Department</th>
                <th className="thHeader">Complaint Title</th>
                <th className="thHeader">Complaint Count</th>
                <th className="thHeader">Created Date</th>
                <th className="thHeader">Attachment</th>
                <th className="thHeader">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10">
                    <Loader />
                  </td>
                </tr>
              ) : curPendingData.length > 0 ? (
                curPendingData.map((item) => (
                  <tr key={item._id}>
                    <td>{item?.ticket}</td>
                    <td>{item?.departmentDetails?.name || "-"}</td>
                    <td>{item?.desc || "-"}</td>
                    <td>
                      {item?.totalComplains ? (
                        <Link to={`/complaint/history/${item._id}`}>
                          {item.totalComplains}
                        </Link>
                      ) : (
                        "0"
                      )}
                    </td>
                    <td>
                      {item?.createdAt
                        ? moment(item.createdAt).format("DD MMM YYYY")
                        : "-"}
                    </td>
                    {/* <td>
                      {item?.complaints?.length > 0
                        ? item.complaints.map((el, i) => (
                            <div key={`attach-${item._id}-${i}`}>
                              <span
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() =>
                                  setShowImage(
                                    `${process.env.REACT_APP_S3_URL || ""}/${
                                      el.image
                                    }`
                                  )
                                }
                              >
                                File {i + 1}
                              </span>
                            </div>
                          ))
                        : "-"}
                    </td> */}
                    <td>
                      {/* <span
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() =>
                          setShowImage(
                            process.env.REACT_APP_S3_URL +
                            "/" +
                            item?.image
                          )
                        }
                      >
                        File
                      </span> */}
                        {item?.assets?.length
                            ? item?.assets.map((el, i) => {
                                return (
                                  <div key={`attach-${i}`}>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() =>
                                        setShowImage(
                                          process.env.REACT_APP_S3_URL +
                                            "/" +
                                            el.url
                                        )
                                      }
                                    >
                                      File {i + 1}
                                    </span>
                                  </div>
                                );
                              })
                            : ""}
                    </td>
                    <td>{item?.remark || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text_center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {curPendingData.length > 0 && (
          <Pagination
            currentPage={pageNo}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={(page) => setPageNo(page)}
            changePageSize={(size) => {
              setPageSize(size);
              setPageNo(1);
            }}
          />
        )}

        <Modal show={showImage} centered onHide={() => setShowImage(null)}>
          <Modal.Body>
            <div style={{ maxHeight: "60vh", overflow: "hidden" }}>
              <img src={showImage} alt="Attachment" />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-dark" onClick={() => setShowImage(null)}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default CompletedRequest;
